export const TOKEN_MINT = "8SCLpKVehUzuFBkqnF1qZu5LrodQDRCEoPVpCsrspump";
export const TOKEN_DECIMALS = 6;

